<template>
  <b-sidebar
    id="sidebar-create-monitoring-report"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Update') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <b-alert
          v-if="errors.length"
          show
          dismissible
          variant="danger"
          class="p-1"
          @dismissed="errors = []"
        >
          <div> {{ $t('Not enough files') }} </div>
          <div
            v-for="error of errors"
            :key="error.workType.id"
          >
            {{ $langName(error.workType) }}: {{ error.count }} {{ $t('pc') }}
          </div>
        </b-alert>

        <validation-observer ref="monitoringReportCreate">
          <b-form-group
            :label="$t('Course')"
            label-for="course"
          >
            <validation-provider
              #default="data"
              :name="$t('Course')"
              rules="required"
            >
              <v-select
                id="course"
                v-model="course"
                :reduce="(option) => option"
                :options="[1,2,3]"
              />
              <small class="text-danger">{{ data.errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            :label="$t('Year')"
            label-for="work_type"
          >
            <validation-provider
              #default="data"
              :name="$t('Year')"
              rules="required"
            >
              <v-select
                id="work_type"
                v-model="period_id"
                :reduce="(option) => option.id"
                :options="periods"
                label="admission_year"
              />

              <small class="text-danger">{{ data.errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- Form Actions -->
        </validation-observer>
        <div class="d-flex mt-2">
          <b-button
            variant="primary"
            class="mr-2"
            type="submit"
            :disabled="isLoading"
            @click="submit(hide)"
          >
            <b-spinner
              v-if="isLoading"
              type="grow"
              small
            />
            {{ $t('Create') }}
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>
<script>
import {
  BButton, BForm, BFormGroup, BSidebar, BSpinner, BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationObserver, localize, ValidationProvider } from 'vee-validate'
import { ScientificWorkTypeList } from '@/classes/ScientificWorkTypes'
import { required } from '@/libs/validations/validations'

export default {
  name: 'MonitoringReportCreate',
  components: {
    ValidationProvider,
    BSpinner,
    BFormGroup,
    BForm,
    BButton,
    BSidebar,
    vSelect,
    ValidationObserver,
    BAlert,
  },
  data() {
    return {
      period_id: null,
      course: null,
      isLoading: false,
      errors: [],
      errorMessage: '',
      required,
    }
  },
  computed: {
    periods() {
      return this.$store.state.staticModule.admissionYearPeriodList
    },
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.period_id = null
      this.course = null
      this.errors = []
      this.$refs.monitoringReportCreate.reset()
      hide()
    },
    submit(hide) {
      this.$refs.monitoringReportCreate.validate().then(success => {
        if (success) {
          this.isLoading = true
          this.$store.dispatch('monitoringReport/create', { period_id: this.period_id, course: this.course })
            .then(() => {
              this.$bvToast.toast(this.$t('Successfully completed'), {
                variant: 'success',
                solid: true,
                title: this.$t('Success'),
              })
              this.$emit('refetchData')
              this.clear(hide)
            })
            .catch(({ response }) => {
              if (response.status === 400) {
                this.showErrors(response.data)
              }
            })
            .finally(() => { this.isLoading = false })
        }
      })
    },
    showErrors(data) {
      this.errors = []
      if (data.message) {
        this.$bvToast.toast(data.message, {
          variant: 'danger',
          solid: true,
        })
      }
      Object.keys(data).forEach(dcType => {
        if (dcType !== 'message') {
          this.errors.push({
            workType: ScientificWorkTypeList.find(item => item.id === Number(dcType)),
            count: data[dcType],
          })
        }
      })
    },
  },
}
</script>
<style scoped>

</style>
